import {Individu} from "@Common/core/services";
import {Planning} from "app/suaps/common/services/planning/plannig.model";


export interface Subscription {
  id?: number;
  planning?: number;
  planning_obj?: Planning;
  member?: string;
  member_obj?: Individu;
  state_subscription?: StateSubscription;
  categorie_cours?: SubscriptionCategorieCours;
  categorie_cours_label?: string;
  ldap_diplome?: string;
  ldap_affectation?: string;
  ldap_cmpsvc?: string;
}

export enum StateSubscription {
  waiting = 1,
  accepted = 2,
  refused = 3,
  canceled = 4,
}

export enum SubscriptionCategorieCours {
  ec_libre = 1,
  loisir = 2,
}
